import React, { useState, useEffect } from 'react';
import PauseService from '../../service/pause';
import { useQueueChatPauseContext } from '../../../../../../hooks/useQueuePauseChatServicePanel';
import { ContentLoading, RowSelect, ColInput } from './styled';
import { useForm } from 'react-hook-form';
import { ButtonLoginInNewQueue } from 'components/Navbars/ServicePanel/sharedComponents/ButtonLoginInNewQueue';
import QueueChatLoginLoader from 'components/ContentLoaders/contentLoaderQueueChatPause';
import { PowerButton } from 'components/Navbars/ServicePanel/sharedComponents/ButtonIndividualLogoutQueue';
import PauseUnpauseForm from '../../../shared/components/PauseUnpauseForm';
import { LogoutFormInput } from '../../../shared/components/LogoutForm/LogoutFormInput';
import { HeadersModalLoginQueues } from '../../../shared/components/headerModalLoginQueues';
import { AddQueueForm } from 'components/Navbars/ServicePanel/shared/components/AddQueueForm/AddQueueForm';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';
import { toast } from 'react-toastify';

export function QueueManagement() {
  const { emitEventUpdateQueueChatCache } =
    useConversationConnectionSocketForMonitoring();

  const {
    handleChangeStatusPauseChat,
    inQueueChatPause,
    queuesChatLoggedValues,
    handleLoginInTheQueuesChat,
    handleLogoutInTheQueuesChat,
    currentPauseId,
    queues
  } = useQueueChatPauseContext();

  const { setValue } = useForm();

  const [loading, setLoading] = useState(false);
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [pauses, setPauses] = useState(new Map());
  const [queuesFree, setQueuesFree] = useState(new Map());
  const [queuesInUse, setQueuesInUse] = useState(new Map());
  const [showLoginInNewQueue, setShowLoginInNewQueue] = useState(false);

  useEffect(() => {
    const getAllPauses = async () => {
      try {
        setLoading(true);
        const { data = [] } = await PauseService.getAll();
        let pauseOrder = data.sort((a, b) => a?.name?.localeCompare(b.name));

        const queuesFreeMap = new Map(queues);
        const queuesLogged = new Set(queuesChatLoggedValues);
        const pausesMap = new Set();

        //Refatorar para evitar muitos loops
        pauseOrder.forEach((pause) => {
          pause.queues.forEach((queue) => {
            if (queuesLogged.has(queue.id)) {
              pausesMap.add(pause);
            }
          });
        });

        queuesChatLoggedValues.forEach((queueId) => {
          queuesFreeMap.delete(queueId);
          queuesInUse.set(queueId, queues.get(queueId));
        });

        setQueuesFree(queuesFreeMap);
        setPauses(pausesMap);
        setLoading(false);
      } catch (err) {
        toast.error('Houve um erro ao buscar as pausas');
        console.log('get pause error', err);
        setLoading(false);
      }
    };
    getAllPauses();
  }, []);

  const handlerPauseOn = async (data) => {
    if (!data?.pauseId || !pauses)
      toast.warning('Selecionar uma pausa para continuar');
    setLoading(true);
    const pause = Array.from(pauses).find((p) => p.id === data?.pauseId);
    await handleChangeStatusPauseChat(true, data?.pauseId, pause);
    setLoading(false);
  };

  const handlerPauseOff = async () => {
    if (inQueueChatPause) {
      setLoading(true);
      await handleChangeStatusPauseChat(false, null, null);
      setLoading(false);
      return;
    }
  };

  const handleLogout = async (data) => {
    try {
      setLoading(true);
      const queuesSelected = data?.queueIds;
      if (inQueueChatPause) {
        toast.warning('Você não pode fazer logout enquanto estiver em pausa');
        setLoading(false);
        return;
      }
      if (queuesSelected.length === 0) {
        toast.warning('Selecione uma fila para fazer logout');
        setLoading(false);
        return;
      }
      let nameQueues = [];

      const queuesFreeMap = new Map(queuesFree);
      const newQueuesInUse = new Map(queuesInUse);

      queuesChatLoggedValues.forEach((queueId) => {
        if (queuesSelected.includes(queueId)) {
          queuesFreeMap.set(queueId, queues.get(queueId));
          nameQueues.push(queues.get(queueId)?.name);
          newQueuesInUse.delete(queueId);
        }
      });

      setQueuesFree(queuesFreeMap);
      const newQueues = await handleLogoutInTheQueuesChat(queuesSelected);
      emitEventUpdateQueueChatCache(newQueues, queues);

      setQueuesInUse(newQueuesInUse);
      setValue('queueIds', '');
      setLoading(false);
    } catch (err) {
      toast.error('Erro ao fazer logout');
      console.log('err', err);
      setLoading(false);
    }
  };

  const handleIndividualLogoff = async (queueId) => {
    try {
      if (inQueueChatPause) {
        toast.info('Você não pode deslogar enquanto estiver em pausa');
        return;
      }
      setLoading(true);

      const queuesInUseMap = new Map(queuesInUse);
      const queuesFreeMap = new Map(queuesFree);

      queuesInUseMap.delete(queueId);
      queuesFreeMap.set(queueId, queues.get(queueId));
      setQueuesFree(queuesFreeMap);
      const newQueues = await handleLogoutInTheQueuesChat([queueId]);
      emitEventUpdateQueueChatCache(newQueues, queues);

      setQueuesInUse(queuesInUseMap);
      setLoading(false);
    } catch (err) {
      toast.error('Erro ao deslogar da fila');
      console.log('err', err);
      setLoading(false);
    }
  };

  const handlerLogin = async (data) => {
    try {
      setLoadingLogin(true);
      const queuesFreeMap = new Map(queuesFree);
      const queuesInUseMap = new Map(queuesInUse);

      data.queueIds.map((queueId) => {
        queuesFreeMap.delete(queueId);
        queuesInUseMap.set(queueId, queues.get(queueId));
      });

      setQueuesFree(queuesFreeMap);
      setQueuesInUse(queuesInUseMap);
      const newQueues = await handleLoginInTheQueuesChat(data.queueIds);
      emitEventUpdateQueueChatCache(newQueues, queues);
      setLoadingLogin(false);
      closeModalNewQueue();
    } catch (err) {
      toast.error('Erro ao logar nas filas do chat');
      console.log('err', err);
      setLoadingLogin(false);
    }
  };

  const showModalNewQueue = () => {
    setShowLoginInNewQueue(true);
  };

  const closeModalNewQueue = () => {
    setShowLoginInNewQueue(false);
  };

  if (loading) {
    return (
      <ContentLoading>
        <QueueChatLoginLoader />
      </ContentLoading>
    );
  }

  if (showLoginInNewQueue) {
    return (
      <>
        <AddQueueForm
          handlerAddQueue={handlerLogin}
          handleCancel={closeModalNewQueue}
          queues={Array.from(queuesFree?.values()) || []}
          loading={loadingLogin}
        />
      </>
    );
  }

  return (
    <>
      <HeadersModalLoginQueues isChat={true} />

      <PauseUnpauseForm
        allPauses={Array.from(pauses?.values()) || []}
        pauses={Array.from(pauses?.values()) || []}
        isPaused={inQueueChatPause}
        handlePause={handlerPauseOn}
        handleUnpause={handlerPauseOff}
        currentPauseId={currentPauseId}
      />

      <LogoutFormInput
        handleLogout={handleLogout}
        shouldSign={false}
        queues={Array.from(queuesInUse?.values()) || []}
        isPaused={inQueueChatPause}
      />

      {queuesChatLoggedValues?.map((queueId, index) => {
        const queue = queues.has(queueId) ? queues.get(queueId) : null;
        if (queue)
          return (
            <RowSelect key={index}>
              <ColInput>
                <span>{queue?.name}</span>
              </ColInput>
              <PowerButton
                isPaused={inQueueChatPause}
                onClick={() => handleIndividualLogoff(queue?.id)}
              />
            </RowSelect>
          );
      })}

      <ButtonLoginInNewQueue
        disabled={inQueueChatPause}
        action={() => {
          showModalNewQueue();
        }}
      />
    </>
  );
}
